import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreFieldsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-fields',
	path: '/jira/core/projects/:projectKey/settings/fields',
	exact: true,
};
